//cookie操作
function getsec(str)
{
  if(str == undefined){
    return str
  }
  if(str == -1){
    return str
  }
  var str1=str.substring(1,str.length)*1;
  var str2=str.substring(0,1);
  if (str2=="s")
  {
    return str1*1000;
  }
  else if (str2=="h")
  {
    return str1*60*60*1000;
  }
  else if (str2=="d")
  {
    return str1*24*60*60*1000;
  }
}
export function getCookie(name)
{
  var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  if(arr=document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}
export function delCookie(name)
  {
    /*  setCookie(name, null, -1);*/
    var strsec = getsec(-1);
    var exp = new Date();
    exp.setTime(exp.getTime() + strsec*1);
    document.cookie = name + "="+ escape (null) + ";expires=" + exp.toGMTString()+"; path=/";
  }
export function setCookie(name,value,time)
    {
      var strsec = getsec(time);
      var exp = new Date();
      exp.setTime(exp.getTime() + strsec*1);
      document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString()+"; path=/";
    }

